function tokenizeQuery(query: string): string[] {
  // Manual single-pass scan (no backtracking regex) so this can't exhibit
  // ReDoS. Splits on whitespace but keeps a `"…"` quoted value together as part
  // of a single token. A `"` only opens a whitespace-spanning quoted section
  // when there is a later `"` to close it; an unterminated quote is treated as a
  // normal character so whitespace still splits it — matching the previous
  // regex, which required a balanced `"…"`.
  const lastQuoteIndex = query.lastIndexOf('"')
  const tokens: string[] = []
  let current = ''
  let inQuotes = false

  for (let i = 0; i < query.length; i++) {
    const char = query[i]
    if (char === '"' && (inQuotes || i < lastQuoteIndex)) {
      inQuotes = !inQuotes
      current += char
    } else if (!inQuotes && char !== undefined && char.trim() === '') {
      if (current) {
        tokens.push(current)
        current = ''
      }
    } else {
      current += char
    }
  }

  if (current) tokens.push(current)
  return tokens
}

function addFilterToQuery(query: string | undefined, prefix: string, value: string): string {
  const filter = `${prefix}:${value}`

  if (!query) return filter

  const filterTerms = tokenizeQuery(query)
  const nonMatchingTerms = filterTerms.filter(term => !term.startsWith(`${prefix}:`))
  if (nonMatchingTerms.length === 0) return filter

  const newQuery = filterTerms.length === nonMatchingTerms.length ? query : nonMatchingTerms.join(' ')
  return `${newQuery} ${filter}`
}

export function addRepoFilterToQuery(query: string | undefined, repo: string): string {
  return addFilterToQuery(query, 'repo', repo)
}

export function addAuthorFilterToQuery(query: string | undefined, author: string): string {
  return addFilterToQuery(query, 'author', author)
}

export function addLabelFilterToQuery(query: string | undefined, label: string): string {
  const labelValue = label.includes(' ') ? `"${label}"` : label
  return addFilterToQuery(query, 'label', labelValue)
}

export function addAssigneeFilterToQuery(query: string | undefined, assignee: string): string {
  return addFilterToQuery(query, 'assignee', assignee)
}

export function addTypeFilterToQuery(query: string | undefined, type: string): string {
  const typeValue = type.includes(' ') ? `"${type}"` : type
  return addFilterToQuery(query, 'type', typeValue)
}
